import React from "react";
import AlianzaEmpaticaNetpay from '../recursos/netpay/alianza-empatica-netpay.png';
import QPM1 from '../recursos/netpay/quickpay-mini.png';
import E100 from '../recursos/netpay/e100.png';
import E200 from '../recursos/netpay/e200.png';
import LogoEmpatica from '../recursos/netpay/logo-empatica.png';
import CajerosGobierno from '../recursos/netpay/cajeros-gobierno.png';
import TerminalesPax from '../recursos/netpay/terminales-pax.png';
import Fondo from '../recursos/netpay/Fondo.png';
import Gasolinera from '../recursos/netpay/gasolinera.png';
import BrochureE100 from '../recursos/netpay/Brochure-e100-brandeado.pdf';
import BrochureE200 from '../recursos/netpay/Brochure-e200-brandeado.pdf';

/**
 * Empática + NetPay — landing original convertida a React.
 * Archivo autónomo: JSX y CSS juntos, sin imports de estilos.
 * Imágenes y brochures importados desde ../recursos.
 * Si algún nombre difiere, cambia únicamente su import.
 */
const styles = `.empatica-netpay {
  --cyan: #00d1ec;
  --white: #f7fbff;
  --line: #00a9d7;
  --night: #00051f;
}
.empatica-netpay *, .empatica-netpay *::before, .empatica-netpay *::after {
  box-sizing: border-box;
}
.empatica-netpay {
  width: 100%;
  min-height: 100%;
  scroll-behavior: smooth;
}
.empatica-netpay {
  margin: 0;
  width: 100%;
  min-height: 100vh;

  color: var(--white);
  font-family: Arial, Helvetica, sans-serif;

  background:
    #00051f
    url("${Fondo}")
    center top / cover
    fixed
    no-repeat;

  overflow-x: hidden;
}
.empatica-netpay {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}
.empatica-netpay main {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;

  background: transparent;
}
.empatica-netpay section {
  width: 100%;
}
.empatica-netpay h1, .empatica-netpay h2, .empatica-netpay h3, .empatica-netpay p, .empatica-netpay figure {
  margin: 0;
}
.empatica-netpay img {
  display: block;
  max-width: 100%;
  height: auto;
}
.empatica-netpay em {
  font-style: normal;
  color: var(--cyan);
}
.empatica-netpay .hero {
  width: 100%;
  min-height: 100vh;

  padding:
    45px
    clamp(20px, 5vw, 90px)
    60px;

  background: transparent;
}
.empatica-netpay .brand {
  width: min(240px, 45vw);
  margin: 0 auto 30px;
}
.empatica-netpay .hero h1 {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: clamp(34px, 5.5vw, 72px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -2.5px;
}
.empatica-netpay .hero h1 em {
  display: block;
}
.empatica-netpay .products {
  width: min(1100px, 100%);
  margin: 45px auto 40px;
}
.empatica-netpay .products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(15px, 3.5vw, 45px);
  align-items: end;
  justify-items: center;
  max-width: 980px;
  margin: 0 auto;
}
.empatica-netpay .product-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  text-align: center;
  transition: transform 0.3s ease;
}
.empatica-netpay .product-item:hover {
  transform: translateY(-8px);
}
.empatica-netpay .product-link {
  display: block;
  text-decoration: none;
  cursor: pointer;
  border-radius: 12px;
  transition: outline 0.2s ease;
}
.empatica-netpay .product-link:focus-visible {
  outline: 3px solid var(--cyan);
  outline-offset: 6px;
}
.empatica-netpay .product-item img {
  max-width: 100%;
  height: auto;
  max-height: clamp(260px, 32vw, 420px);
  object-fit: contain;
  display: block;
  filter:
    drop-shadow(0 18px 25px rgba(0, 0, 0, 0.60))
    drop-shadow(0 0 15px rgba(0, 209, 236, 0.12));
  transition: filter 0.3s ease;
}
.empatica-netpay .product-item:hover img {
  filter:
    drop-shadow(0 26px 34px rgba(0, 0, 0, 0.70))
    drop-shadow(0 0 25px rgba(0, 209, 236, 0.28));
}
.empatica-netpay .product-item figcaption {
  margin-top: 18px;
  font-size: clamp(15px, 1.8vw, 22px);
  font-weight: 700;
  color: var(--white);
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
}
.empatica-netpay #beneficios {
  width: 100%;
  max-width: 1200px;
  margin: 45px auto 0;
}
.empatica-netpay .features {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.empatica-netpay .feature {
  display: flex;
  align-items: center;
  gap: 22px;
  min-height: 130px;
  padding: 22px;
  border: 1px solid rgba(0, 169, 215, 0.75);
  border-radius: 16px;
  background: linear-gradient(
    120deg,
    rgba(0, 31, 64, 0.75),
    rgba(0, 5, 31, 0.8)
  );
  box-shadow:
    inset 0 0 30px rgba(0, 113, 170, 0.12),
    0 8px 30px rgba(0, 0, 0, 0.12);
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.empatica-netpay .feature:hover {
  transform: translateY(-3px);
  border-color: var(--cyan);
  box-shadow:
    inset 0 0 30px rgba(0, 113, 170, 0.18),
    0 12px 35px rgba(0, 0, 0, 0.2);
}
.empatica-netpay .feature svg {
  width: 62px;
  height: 62px;
  flex-shrink: 0;
  color: var(--cyan);
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.empatica-netpay .feature-content {
  min-width: 0;
}
.empatica-netpay .feature h2 {
  margin-bottom: 7px;
  font-size: clamp(16px, 2vw, 22px);
  line-height: 1.08;
}
.empatica-netpay .feature p {
  font-size: clamp(14px, 1.65vw, 18px);
  line-height: 1.35;
  color: rgba(247, 251, 255, 0.9);
}
.empatica-netpay .alliance {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  white-space: nowrap;
}
.empatica-netpay .alliance img {
  flex-shrink: 0;
}
.empatica-netpay .alliance p {
  margin: 0;
  white-space: nowrap;
}
.empatica-netpay .sectors {
  text-align: center;
  font-size: 18px;
  letter-spacing: 1.5px;
  padding: 18px 10px;
}
.empatica-netpay .cta-wrap {
  text-align: center;
  padding-top: 5px;
}
.empatica-netpay .cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  min-height: 56px;
  padding: 14px 34px;
  border-radius: 50px;
  background: var(--cyan);
  color: #00101d;
  text-decoration: none;
  font-weight: 800;
  font-size: clamp(17px, 2vw, 23px);
  box-shadow: 0 8px 30px rgba(0, 209, 236, 0.18);
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.empatica-netpay .cta:hover {
  background: #62eeff;
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(0, 209, 236, 0.3);
}
.empatica-netpay a:focus-visible {
  outline: 3px solid white;
  outline-offset: 5px;
}
.empatica-netpay .arrow {
  font-size: 30px;
  line-height: 1;
}
.empatica-netpay .fine {
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--cyan);
}
.empatica-netpay .proof {
  width: 100%;

  padding:
    80px
    clamp(20px, 5vw, 90px)
    60px;

  background: transparent;
}
.empatica-netpay .proof-header {
  width: min(1200px, 100%);
  margin: 0 auto 35px;
  text-align: left;
}
.empatica-netpay .eyebrow {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  letter-spacing: 3px;
  font-size: 13px;
  color: var(--white);
}
.empatica-netpay .eyebrow::before {
  content: "";
  width: 40px;
  height: 3px;
  flex-shrink: 0;
  background: var(--cyan);
}
.empatica-netpay .proof h2 {
  width: 100%;
  margin: 0;
  font-size: clamp(38px, 6vw, 76px);
  line-height: 1.02;
  letter-spacing: -2.5px;
  font-weight: 800;
}
.empatica-netpay .proof h2 em {
  display: block;
  color: var(--cyan);
}
.empatica-netpay .subtitle {
  width: 100%;
  margin-top: 14px;
  font-size: clamp(18px, 2.2vw, 26px);
  color: rgba(247, 251, 255, 0.9);
}
.empatica-netpay #gobierno {
  width: min(1200px, 100%);
  margin: 20px auto 0;
}
.empatica-netpay .government {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 1.35fr);
  align-items: center;
  gap: clamp(25px, 4.5vw, 55px);
}
.empatica-netpay .government-content h3 {
  font-size: clamp(26px, 3.6vw, 42px);
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -1px;
}
.empatica-netpay .government-content .government-sub {
  margin-top: 12px;
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 700;
  color: rgba(247, 251, 255, 0.95);
  line-height: 1.35;
}
.empatica-netpay .government-content .government-models {
  margin-top: 10px;
  font-size: clamp(15px, 1.8vw, 20px);
  color: var(--cyan);
  font-weight: 600;
}
.empatica-netpay .government-media {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.empatica-netpay .government-media img {
  width: 100%;
  max-width: 620px; 
  height: auto;
  border-radius: 0; 
  box-shadow: none;
  background: transparent;
  filter:
    drop-shadow(0 20px 30px rgba(0, 0, 0, 0.60))
    drop-shadow(0 0 20px rgba(0, 209, 236, 0.16));
  transition: transform 0.3s ease, filter 0.3s ease;
}
.empatica-netpay .government-media img:hover {
  transform: scale(1.03);
  filter:
    drop-shadow(0 26px 40px rgba(0, 0, 0, 0.70))
    drop-shadow(0 0 32px rgba(0, 209, 236, 0.28));
}
.empatica-netpay #trayectoria {
  width: min(1200px, 100%);
  margin: 45px auto 0;
}
.empatica-netpay .caption {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 15px;
  letter-spacing: 0.5px;
}
.empatica-netpay .caption::before {
  content: "";
  width: 36px;
  height: 3px;
  background: var(--cyan);
}
.empatica-netpay .stats {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr) minmax(0, 1.65fr);
  gap: 14px;
}
.empatica-netpay .stat {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 22px;
  border: 1px solid rgba(97, 189, 216, 0.8);
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(0, 43, 72, 0.6),
    rgba(0, 5, 31, 0.95)
  );
}
.empatica-netpay .stat strong {
  font-size: clamp(56px, 8vw, 92px);
  line-height: 0.95;
  letter-spacing: -3px;
  background: linear-gradient(white 15%, #e4ffff 30%, #00c8ed 82%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.empatica-netpay .stat strong small {
  font-size: 0.44em;
  letter-spacing: -1px;
}
.empatica-netpay .stat b {
  font-size: clamp(17px, 2.3vw, 25px);
  line-height: 1.06;
}
.empatica-netpay .stat span {
  margin-top: 5px;
  font-size: 13px;
  color: rgba(247, 251, 255, 0.85);
}
.empatica-netpay .stat::after {
  content: "";
  width: 46px;
  height: 2px;
  margin-top: 14px;
  background: var(--cyan);
}
.empatica-netpay #tecnologia {
  width: min(1200px, 100%);
  margin: 18px auto 0;
}
.empatica-netpay .certified {
  background:
    linear-gradient(
      135deg,
      rgba(0, 24, 61, 0.62),
      rgba(0, 5, 31, 0.48)
    );

  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 16px;
  padding: 30px;
}
.empatica-netpay .certified h3 {
  font-size: clamp(26px, 3.5vw, 40px);
  line-height: 1.1;
  letter-spacing: -1px;
}
.empatica-netpay .certified > p {
  margin: 7px 0;
  font-size: clamp(16px, 2vw, 20px);
}
.empatica-netpay .terminal-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px;
  align-items: center;
  gap: 30px;
}
.empatica-netpay .terminal-row figure img {
  width: 100%;
}
.empatica-netpay .terminal-labels {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 6px 0 14px;
}
.empatica-netpay .point {
  border-left: 1px solid rgba(134, 173, 195, 0.8);
  padding: 25px 0 25px 20px;
  font-size: 14px;
}
.empatica-netpay .point strong {
  display: block;
  font-size: 20px;
}
.empatica-netpay .experience {
  border-top: 1px solid var(--cyan);
  text-align: center;
  font-size: clamp(18px, 2.5vw, 26px);
  font-weight: bold;
  padding: 18px 0 0;
}
.empatica-netpay footer.gas-banner {
  position: relative;
  width: 100%;
  margin: 60px 0 0 0;
  padding: 0;

  overflow: hidden;
  isolation: isolate;

  color: #fff;

  border-top: 1px solid rgba(0, 209, 236, 0.45);
  box-shadow: 0 -10px 40px rgba(0, 5, 31, 0.8);

  background:
    linear-gradient(
      90deg,
      rgba(0, 5, 31, 0.98) 0%,
      rgba(0, 5, 31, 0.92) 35%,
      rgba(0, 5, 31, 0.60) 65%,
      rgba(0, 5, 31, 0.25) 100%
    ),
    url("${Gasolinera}")
      center center / cover
      no-repeat;
}
.empatica-netpay .gas-banner__inner {
  position: relative;
  width: 100%;
  max-width: 1400px;
  min-height: 600px;

  margin: 0 auto;
  padding: 70px clamp(25px, 6vw, 90px) 60px;

  display: flex;
  align-items: center;

  overflow: hidden;
}
.empatica-netpay .gas-banner__content {
  position: relative;
  z-index: 5;

  width: 54%;
  max-width: 680px;
}
.empatica-netpay .gas-banner__eyebrow {
  margin: 0 0 16px;

  color: var(--cyan);

  font-size: clamp(12px, 1.2vw, 17px);
  font-weight: 700;

  letter-spacing: .20em;
}
.empatica-netpay .gas-banner__title {
  margin: 0 0 22px;

  font-size: clamp(38px, 4.8vw, 72px);
  line-height: 1.02;

  letter-spacing: -2.5px;
  font-weight: 800;

  text-shadow:
    0 5px 25px rgba(0, 0, 0, .65);
}
.empatica-netpay .gas-banner__title span {
  color: var(--cyan);
}
.empatica-netpay .gas-banner__description {
  max-width: 600px;

  margin: 0;

  font-size: clamp(15px, 1.45vw, 22px);
  line-height: 1.45;

  color: rgba(255, 255, 255, .94);

  text-shadow:
    0 2px 12px rgba(0, 0, 0, .5);
}
.empatica-netpay .gas-banner__action {
  margin-top: 30px;
}
.empatica-netpay .gas-banner__button {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  gap: 14px;

  min-height: 56px;

  padding: 15px 28px;

  border-radius: 50px;

  background: var(--cyan);
  color: #00101d;

  text-decoration: none;

  font-size: clamp(15px, 1.4vw, 20px);
  font-weight: 800;

  box-shadow:
    0 10px 35px rgba(0, 209, 236, .28);

  transition:
    background .25s ease,
    transform .25s ease,
    box-shadow .25s ease;
}
.empatica-netpay .gas-banner__button:hover {
  background: #62eeff;

  transform: translateY(-3px);

  box-shadow:
    0 15px 45px rgba(0, 209, 236, .38);
}
.empatica-netpay .gas-banner__button span {
  font-size: 1.4em;
}
.empatica-netpay .gas-banner__station {
  position: absolute;
  z-index: 4;

  right: 5%;
  top: 50%;

  width: clamp(280px, 34vw, 480px);

  transform: translateY(-50%);

  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: auto;
}
.empatica-netpay .gas-banner__station a {
  display: block;
  cursor: pointer;
  border-radius: 16px;

  transition: transform .35s ease;
}
.empatica-netpay .gas-banner__station a:hover {
  transform: translateY(-6px);
}
.empatica-netpay .gas-banner__station img {
  display: block;

  width: 100%;
  height: auto;

  object-fit: contain;

  filter:
    drop-shadow(0 22px 28px rgba(0, 0, 0, .60))
    drop-shadow(0 0 18px rgba(0, 209, 236, .08));

  transition:
    filter .35s ease;
}
.empatica-netpay .gas-banner__station a:hover img {
  filter:
    drop-shadow(0 28px 34px rgba(0, 0, 0, .65))
    drop-shadow(0 0 28px rgba(0, 209, 236, .25));
}
.empatica-netpay .gas-banner__note {
  position: absolute;

  z-index: 6;

  left: 0;
  right: 0;
  bottom: 12px;

  padding: 0 20px;

  text-align: center;

  color: rgba(230, 240, 245, .75);

  font-size: 12px;
}
.empatica-netpay .closing-section {
  width: 100%;
  background: rgba(0, 5, 31, 0.95);
  border-top: 1px solid rgba(0, 209, 236, 0.3);
  padding: 22px 20px;
  text-align: center;
  position: relative;
  z-index: 7;
}
.empatica-netpay .closing {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  font-size: clamp(15px, 1.7vw, 19px);
  line-height: 1.5;
  color: var(--white);
}
.empatica-netpay .closing em {
  color: var(--cyan);
}
@media (min-width: 1400px) {.empatica-netpay .hero {
    padding-left: 8vw;
    padding-right: 8vw;
  }
.empatica-netpay .proof {
    width: 100%;
    padding: 80px clamp(20px, 5vw, 90px) 60px;
    background: transparent;
  }
.empatica-netpay .products {
    max-width: 1250px;
  }
.empatica-netpay #beneficios, .empatica-netpay .proof-header, .empatica-netpay #gobierno, .empatica-netpay #trayectoria, .empatica-netpay #tecnologia {
    width: min(1200px, 100%);
    margin-left: auto;
    margin-right: auto;
  }}
@media (max-width: 1100px) {.empatica-netpay .gas-banner__content {
    width: 56%;
  }
.empatica-netpay .gas-banner__station {
    right: 2%;
    width: clamp(250px, 38vw, 410px);
  }}
@media (max-width: 900px) {.empatica-netpay .hero {
    padding: 35px 28px 45px;
  }
.empatica-netpay .features {
    grid-template-columns: 1fr 1fr;
  }
.empatica-netpay .feature {
    min-height: 120px;
    padding: 18px;
    gap: 15px;
  }
.empatica-netpay .feature svg {
    width: 52px;
    height: 52px;
  }
.empatica-netpay .government {
    grid-template-columns: 1fr;
    gap: 25px;
    text-align: center;
  }
.empatica-netpay .government-media img {
    max-width: 480px;
    margin: 0 auto;
  }
.empatica-netpay .terminal-row {
    grid-template-columns: 1fr 110px;
  }
.empatica-netpay footer.gas-banner {
    min-height: 580px;

    background:
      linear-gradient(
        90deg,
        rgba(0, 5, 31, .96) 0%,
        rgba(0, 5, 31, .88) 45%,
        rgba(0, 5, 31, .40) 100%
      ),
      url("${Gasolinera}")
        center center / cover
        no-repeat;
  }
.empatica-netpay .gas-banner__inner {
    min-height: 540px;
    padding: 55px 30px 50px;
  }
.empatica-netpay .gas-banner__content {
    width: 58%;
  }
.empatica-netpay .gas-banner__station {
    right: -1%;
    width: min(390px, 42vw);
  }}
@media (max-width: 600px) {.empatica-netpay .hero {
    min-height: auto;
    padding: 25px 16px 40px;
  }
.empatica-netpay .brand {
    position: relative;
    z-index: 3;
    width: min(240px, 45vw);
    margin: 0 auto 30px;
    filter: drop-shadow(0 4px 15px rgba(0, 0, 0, 0.35));
  }
.empatica-netpay .hero h1 {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    font-size: clamp(34px, 5.5vw, 72px);
    font-weight: 800;
    line-height: 1;
    letter-spacing: -2.5px;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
  }
.empatica-netpay .products {
    margin-top: 30px;
    margin-bottom: 25px;
  }
.empatica-netpay .products-grid {
    gap: 10px;
  }
.empatica-netpay .product-item img {
    max-height: 220px;
  }
.empatica-netpay .product-item figcaption {
    font-size: 13px;
    margin-top: 8px;
  }
.empatica-netpay #beneficios {
    width: min(1200px, 100%);
    margin: 45px auto 0;
  }
.empatica-netpay .features {
    grid-template-columns: 1fr;
    gap: 12px;
  }
.empatica-netpay .feature {
    min-height: 0;
    padding: 16px;
    border-radius: 14px;
    gap: 15px;
  }
.empatica-netpay .feature svg {
    width: 46px;
    height: 46px;
  }
.empatica-netpay .feature h2 {
    font-size: 17px;
  }
.empatica-netpay .feature p {
    font-size: 15px;
    line-height: 1.3;
  }
.empatica-netpay .alliance {
    flex-direction: column;
    gap: 10px;
    margin-top: 28px;
    padding: 16px 10px;
    text-align: center;
  }
.empatica-netpay .alliance p {
    padding: 0;
    border-left: 0;
    line-height: 1.5;
  }
.empatica-netpay .sectors {
    padding: 14px 5px;
    font-size: 12px;
    line-height: 1.7;
    letter-spacing: 0.5px;
  }
.empatica-netpay .cta {
    box-shadow:
      0 8px 30px rgba(0, 209, 236, 0.25),
      0 0 20px rgba(0, 209, 236, 0.10);
  }
.empatica-netpay .arrow {
    font-size: 27px;
  }
.empatica-netpay .proof {
    padding: 40px 16px 40px;
  }
.empatica-netpay .eyebrow {
    font-size: 9px;
    letter-spacing: 1.6px;
    gap: 10px;
  }
.empatica-netpay .eyebrow::before {
    width: 28px;
  }
.empatica-netpay .proof h2 {
    font-size: clamp(34px, 10vw, 50px);
    letter-spacing: -1.5px;
  }
.empatica-netpay .subtitle {
    font-size: 16px;
    line-height: 1.3;
  }
.empatica-netpay .proof-header, .empatica-netpay #gobierno {
    width: min(1200px, 100%);
    margin-left: auto;
    margin-right: auto;
  }
.empatica-netpay .government-media img {
    max-width: 100%;
  }
.empatica-netpay #trayectoria {
    margin-top: 30px;
  }
.empatica-netpay .stats {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
.empatica-netpay .stat {
    padding: 17px;
    border-radius: 13px;
  }
.empatica-netpay .stat:last-child {
    grid-column: 1 / -1;
  }
.empatica-netpay .stat strong {
    font-size: 58px;
  }
.empatica-netpay .stat:last-child strong {
    font-size: 68px;
  }
.empatica-netpay .stat b {
    font-size: 18px;
  }
.empatica-netpay #tecnologia {
    margin-top: 14px;
  }
.empatica-netpay .certified {
    padding: 20px 14px;
    border-radius: 14px;
  }
.empatica-netpay .certified h3 {
    font-size: 27px;
  }
.empatica-netpay .certified > p {
    font-size: 15px;
    line-height: 1.35;
  }
.empatica-netpay .terminal-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
.empatica-netpay .terminal-labels {
    font-size: 10px;
    margin-bottom: 12px;
  }
.empatica-netpay .point {
    border-left: 0;
    border-top: 1px solid rgba(134, 173, 195, 0.8);
    padding: 12px 0;
    text-align: center;
  }
.empatica-netpay .point strong {
    display: inline;
    font-size: 16px;
  }
.empatica-netpay .experience {
    font-size: 17px;
    padding: 15px 0 0;
  }
.empatica-netpay footer.gas-banner {
    min-height: 680px;
    margin-top: 40px;

    background:
      linear-gradient(
        180deg,
        rgba(0, 5, 31, .96) 0%,
        rgba(0, 5, 31, .88) 42%,
        rgba(0, 5, 31, .55) 72%,
        rgba(0, 5, 31, .28) 100%
      ),
      url("${Gasolinera}")
        center center / cover
        no-repeat;
  }
.empatica-netpay .gas-banner__inner {
    min-height: 620px;
    padding: 45px 20px 75px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
.empatica-netpay .gas-banner__content {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
.empatica-netpay .gas-banner__eyebrow {
    margin-bottom: 15px;
    font-size: 11px;
    letter-spacing: .14em;
  }
.empatica-netpay .gas-banner__title {
    margin-bottom: 20px;
    font-size: clamp(32px, 8.5vw, 50px);
    line-height: 1.04;
    letter-spacing: -1.5px;
  }
.empatica-netpay .gas-banner__description {
    max-width: 520px;
    margin: 0 auto;
    font-size: 16px;
    line-height: 1.5;
  }
.empatica-netpay .gas-banner__action {
    margin-top: 25px;
  }
.empatica-netpay .gas-banner__button {
    width: 100%;
    min-height: 54px;
    padding: 15px 18px;
    border-radius: 18px;
    font-size: 15px;
  }
.empatica-netpay .gas-banner__station {
    right: auto;
    left: 50%;
    top: auto;
    bottom: 25px;
    width: min(290px, 72vw);
    transform: translateX(-50%);
  }
.empatica-netpay .gas-banner__note {
    bottom: 8px;
    font-size: 9px;
    padding: 0 12px;
  }
.empatica-netpay .closing-section {
    padding: 18px 16px;
  }
.empatica-netpay .closing {
    font-size: 14px;
  }}
@media (max-width: 380px) {.empatica-netpay .hero {
    padding-left: 12px;
    padding-right: 12px;
  }
.empatica-netpay .proof {
    padding-left: 12px;
    padding-right: 12px;
  }
.empatica-netpay .hero h1 {
    font-size: 30px;
  }
.empatica-netpay .feature {
    padding: 14px;
  }
.empatica-netpay .feature svg {
    width: 40px;
    height: 40px;
  }
.empatica-netpay .feature h2 {
    font-size: 15px;
  }
.empatica-netpay .feature p {
    font-size: 14px;
  }
.empatica-netpay .stats {
    grid-template-columns: 1fr;
  }
.empatica-netpay .stat:last-child {
    grid-column: auto;
  }}
@media (prefers-reduced-motion: reduce) {.empatica-netpay .product-item {
    transition: none;
  }
.empatica-netpay .product-item img {
    transition: none;
  }
.empatica-netpay .government-media img {
    transition: none;
  }
.empatica-netpay .gas-banner__station img {
    transition: none;
  }
.empatica-netpay .gas-banner__button {
    transition: none;
  }}

/* Aislamiento frente a los estilos de la aplicación anfitriona */
.empatica-netpay {
  display: flow-root;
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 100%;
  overflow-x: clip;
  isolation: isolate;
  color: #f7fbff;
  font-family: Arial, Helvetica, sans-serif;
  background: #00051f url("${Fondo}") center top / cover no-repeat;
}
.empatica-netpay, .empatica-netpay * { box-sizing: border-box; }
.empatica-netpay main,
.empatica-netpay section,
.empatica-netpay footer { position: relative; height: auto; max-height: none; }
.empatica-netpay .hero { min-height: 0; display: flow-root; }
.empatica-netpay .products { margin-bottom: 45px; }
.empatica-netpay #beneficios { margin-top: 30px; margin-bottom: 45px; }
.empatica-netpay .features { width: 100%; }
.empatica-netpay .feature { min-width: 0; height: auto; }
.empatica-netpay .feature-content p { overflow-wrap: anywhere; }
.empatica-netpay .alliance {
  width: min(1200px, 100%); margin: 0 auto 12px; padding: 12px 0;
  flex-wrap: wrap; white-space: normal;
}
.empatica-netpay .alliance p { white-space: normal; text-align: center; }
.empatica-netpay .sectors {
  max-width: 1200px; margin: 0 auto 16px;
  line-height: 1.8; overflow-wrap: anywhere;
}
.empatica-netpay .cta-wrap { margin: 0 auto 12px; }
.empatica-netpay .proof { clear: both; display: flow-root; padding-top: 85px; }
.empatica-netpay .proof-header { margin-bottom: 38px; }
.empatica-netpay .proof h2 { overflow-wrap: anywhere; }
.empatica-netpay .government-media img { display: block; }
.empatica-netpay .gas-banner__inner { box-sizing: border-box; }
@media (max-width: 900px) {
 .empatica-netpay .proof { padding-top: 55px; }
 .empatica-netpay .alliance { gap: 12px; }
 .empatica-netpay .sectors { font-size: 15px; letter-spacing: .5px; }
}
@media (max-width: 600px) {
 .empatica-netpay .hero { padding-bottom: 38px; }
 .empatica-netpay .products-grid { grid-template-columns: repeat(3,minmax(0,1fr)); }
 .empatica-netpay #beneficios { margin: 35px auto 28px; }
 .empatica-netpay .alliance { flex-direction: column; padding: 14px 0; }
 .empatica-netpay .alliance p { font-size: 14px; }
 .empatica-netpay .sectors { font-size: 13px; line-height: 1.85; }
 .empatica-netpay .proof { padding-top: 46px; }
 .empatica-netpay .stats { grid-template-columns: 1fr 1fr; }
 .empatica-netpay .gas-banner__inner {
   display: flex; flex-direction: column; align-items: center;
   min-height: 0; height: auto; overflow: visible; padding-bottom: 55px;
 }
 .empatica-netpay .gas-banner__content { width: 100%; max-width: 600px; }
 .empatica-netpay .gas-banner__station {
   position: relative; inset: auto; transform: none;
   width: min(290px,75vw); margin: 28px auto 0;
 }
 .empatica-netpay .gas-banner__note {
   position: relative; left: auto; right: auto; bottom: auto;
   margin-top: 22px;
 }
}
@media (max-width: 380px) {
 .empatica-netpay .stats { grid-template-columns: 1fr; }
 .empatica-netpay .products-grid { gap: 6px; }
 .empatica-netpay .product-item figcaption { font-size: 11px; }
}
`;

export default function EmpaticaNetPay() {
  return (
    <div className="empatica-netpay">
      <style>{styles}</style>
      <main>

<section id="soluciones-cobro" className="hero" aria-labelledby="hero-title">
<img className="brand" src={AlianzaEmpaticaNetpay} alt="Empática Soluciones y NetPay" width="240" height="45" />
<h1 id="hero-title">Cobra en efectivo y tarjeta.<em>Gana control sobre tus ingresos.</em>
</h1>

<div className="products">
<div className="products-grid">
<figure className="product-item">
<img src={QPM1} alt="Cajero QuickPay Mini" loading="lazy" />
<figcaption>QuickPay Mini</figcaption>
</figure>
<figure className="product-item">
<a href={BrochureE100} target="_blank" rel="noopener noreferrer" className="product-link" title="Abrir Brochure e100 en otra ventana">
<img src={E100} alt="Cajero e100" loading="lazy" />
</a>
<figcaption>e100</figcaption>
</figure>
<figure className="product-item">
<a href={BrochureE200} target="_blank" rel="noopener noreferrer" className="product-link" title="Abrir Brochure e200 en otra ventana">
<img src={E200} alt="Cajero e200" loading="lazy" />
</a>
<figcaption>e200</figcaption>
</figure>
</div>
</div>

<section id="beneficios" aria-label="Beneficios de las soluciones de cobro">
<div className="features">
<article className="feature">
<svg viewBox="0 0 64 64" aria-hidden="true">
<path d="M5 12h40v28H5zM10 6h40v6M16 1h40v12"></path>
<circle cx="25" cy="26" r="7"></circle>
<rect x="28" y="33" width="32" height="23" rx="3"></rect>
<path d="M28 41h32M48 49h5"></path>
</svg>
<div className="feature-content">
<h2>COBROS AUTOMATIZADOS</h2>
<p>Recibe pagos en efectivo y tarjeta con cajeros de autocobro.</p>
</div>
</article>
<article className="feature">
<svg viewBox="0 0 64 64" aria-hidden="true">
<path d="M26 21l10-10a12 12 0 0 1 17 17L42 39M38 43L28 53a12 12 0 0 1-17-17l11-11M23 41l18-18"></path>
</svg>
<div className="feature-content">
<h2>INTEGRACIÓN CON TU POS</h2>
<p>Conecta tus cobros con sistemas compatibles como Sicar, Odoo, SoftRestaurant, Eleventa y Otros....</p>
</div>
</article>
<article className="feature">
<svg viewBox="0 0 64 64" aria-hidden="true">
<path d="M5 57h54M12 55V38h7v17M27 55V24h7v31M42 55V9h7v46"></path>
</svg>
<div className="feature-content">
<h2>CONTROL Y TRAZABILIDAD</h2>
<p>Facilita la conciliación y el seguimiento de tus ingresos.</p>
</div>
</article>
<article className="feature">
<svg viewBox="0 0 64 64" aria-hidden="true">
<circle cx="32" cy="32" r="24"></circle>
<path d="m20 32 9 9 16-19"></path>
</svg>
<div className="feature-content">
<h2>PAGOS MÁS SENCILLOS</h2>
<p>Proceso guiado, confirmación inmediata y menos filas.</p>
</div>
</article>
</div>
</section>

<div id="alianza" className="alliance">
<img src={LogoEmpatica} alt="Empática Soluciones" width="132" height="38" />
<p><strong>Empática</strong> conecta tu operación.   <strong>Net<em>Pay</em></strong> procesa los pagos con tarjeta.</p>
</div>
<p className="sectors">Gimnasios   •   Carnicerías   •   Ferreterías   •   Minisúper •   Gasolineras •   Refaccionarias •   Cafeterias •   Comida Rapida</p>

<div id="contacto" className="cta-wrap">
<a className="cta" href="https://wa.me/524434799929?text=Hola%2C%20Emp%C3%A1tica.%20Quisiera%20agendar%20una%20demostraci%C3%B3n%20de%20sus%20cajeros%20y%20terminales." target="_blank" rel="noopener noreferrer">Agenda una demo para tu negocio <span className="arrow" aria-hidden="true">→</span></a>
<p className="fine">Compatibilidad e integración según el sistema y la configuración.</p>
</div>
</section>

<section id="respaldo" className="proof" aria-labelledby="proof-title">
<div className="proof-header">
<p className="eyebrow">EXPERIENCIA QUE RESPALDA TU INVERSIÓN</p>
<h2 id="proof-title">Tu próximo paso, <em>con respaldo real.</em></h2>
<p className="subtitle">Tecnología con experiencia en negocios y organismos públicos.</p>
</div>

<section id="gobierno" aria-labelledby="government-title">
<div className="government">
<div className="government-content">
<h3 id="government-title">Soluciones <em>para gobierno</em></h3>
<h3 className="government-sub">Organismos de Agua Potable y Ayuntamientos</h3>
<p className="government-models">QuickPay 101 • e300 • QuickPay 301</p>
</div>
<div className="government-media">
<img src={CajerosGobierno} alt="Soluciones de cajeros para gobierno" loading="lazy" />
</div>
</div>
</section>

<section id="trayectoria" aria-labelledby="stats-title">
<p id="stats-title" className="caption">Trayectoria operativa de Empática</p>
<div className="stats">
<article className="stat"><strong>21</strong><b>estados de México</b><span>con cajeros QuickPay operando</span></article>
<article className="stat"><b>Más de</b><strong>140</strong><b>cajeros operando</b></article>
<article className="stat"><strong>6.6 <small>millones</small></strong><b>de transacciones al año</b></article>
</div>
</section>

<section id="tecnologia" className="certified" aria-labelledby="technology-title">
<h3 id="technology-title"><em>Tecnología certificada</em> y lista para operar</h3>
<p>Soluciones y terminales certificadas y validadas para proyectos de aceptación de pagos.</p>
<div className="terminal-row">
<figure>
<img src={TerminalesPax} alt="Terminales PAX A910S, PAX IM30 y PAX ARIES 8" width="400" height="120" loading="lazy" />
<figcaption className="terminal-labels"><span>PAX A910S</span><span>PAX IM30</span><span>PAX ARIES 8</span></figcaption>
</figure>
<p className="point">También: <strong>Empática Point</strong></p>
</div>
<p className="experience">Experiencia en iniciativa <em>privada y gobierno.</em></p>
</section>
</section>
</main>

<footer id="gasolineras" className="gas-banner" aria-labelledby="gas-title">
<div className="gas-banner__inner">
<div className="gas-banner__content">
<p className="gas-banner__eyebrow">SOLUCIONES PARA GASOLINERAS</p>
<h2 id="gas-title" className="gas-banner__title">
            Conecta tus cobros
            <br />
            con tu
            <span>sistema volumétrico.</span>
</h2>
<p className="gas-banner__description">
            Integra los pagos con tarjeta y efectivo a la operación
            de tu gasolinera mediante nuestra conexión con los
            principales sistemas volumétricos.
          </p>
<div className="gas-banner__action">
<a className="gas-banner__button" href="https://wa.me/524434799929?text=Hola%2C%20Emp%C3%A1tica.%20Me%20interesa%20conocer%20la%20integraci%C3%B3n%20de%20cobros%20con%20el%20sistema%20volum%C3%A9trico%20de%20mi%20gasolinera." target="_blank" rel="noopener noreferrer">
              Consulta la integración para tu estación
              <span aria-hidden="true">→</span>
</a>
</div>
</div>

<div className="gas-banner__station">
<a href={BrochureE100} target="_blank" rel="noopener noreferrer" title="Abrir Brochure e100 en otra ventana">
<img src={E100} alt="Cajero e100" />
</a>
</div>
<p className="gas-banner__note">
          Compatibilidad y alcance de integración según el sistema y la solución de cobro.
        </p>
</div>

<div id="cierre" className="closing-section">
<p className="closing">
          La integración no parte de cero. <em>La tecnología <strong>ya está validada para operar.</strong></em>
</p>
</div>
</footer>
    </div>
  );
}
